import { Component, Input, OnInit } from '@angular/core';
declare var $;
@Component({
  selector: 'app-sw-triple-search',
  templateUrl: './sw-triple-search.component.html',
  styleUrls: ['./sw-triple-search.component.css']
})
export class SwTripleSearchComponent implements OnInit {

  // 快捷操作：打开或关闭实体素材库检索组件
  @Input() state:string

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(){
    console.log('tripleSearchBox',this.state);
    if(this.state == 'open'){
      $('.tripleSearchBox').css('left','250px');
    }else{
      $('.tripleSearchBox').css('left','-520px');
    }
  }

  // 执行关闭操作，需关闭右侧弹出框
  componentStateChange(event){
    $('.tripleSearchBox').css('left','-520px');
  }
}
